<div class="row" *ngIf="ViolationInfo!=null">
    <div class="col-sm-12">
        <div class="custom-form">
            <div *ngIf="ViolationInfo" class="row justify-content-between">
                <div class="col-lg-12">
                    <div class="card p-3">
                        <h5 class="mb-0 text-secondary">
                            {{ "BasicInformation" | translate }}
                        </h5>
                        <hr class="mb-3" />
                        <div class="form-group row">
                            <div *ngIf="ViolationInfo.applicationName" class="col-4">
                                <label>{{ "ApplicationName" | translate }}</label>
                                <span class="form-control"
                                      readonly>{{ViolationInfo.applicationName}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.violationNo" class="col-4">
                                <label>{{ "CaseNumber" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.violationNo}}&nbsp;</span>
                            </div>

                        </div>
                        <div class="form-group row">
                            <div *ngIf="ViolationInfo.committeeName" class="col-4">
                                <label>{{ "CommitteeName" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.committeeName}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.year" class="col-4">
                                <label>{{ "HijriYear" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.year}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.endDate" class="col-4">
                                <label>{{ "objectionDate" | translate }}</label>
                                <span class="form-control" readonly>
                                    {{  ViolationInfo.endDate | toDateOnly  }}&nbsp;
                                </span>
                            </div>
                        </div>



                        <div class="form-group mt-3 row">
                            <div *ngIf="ViolationInfo.description" class="col-12">
                                <label> {{ "violationDescription" | translate }} </label>
                                <textarea class="form-control" style="height:200px" [(ngModel)]="ViolationInfo.description"
                                          readonly ></textarea>

                            </div>
                        </div>

                        <div class="form-group mt-3 row">
                            <div *ngIf="ViolationInfo.questioning" style="height:200px" class="col-12">
                                <label>{{ "Questioning" | translate }}</label>
                                <textarea class="form-control" [(ngModel)]="ViolationInfo.questioning"
                                          readonly></textarea>
                            </div>
                        </div>
                        <div class="form-group mt-3 row">

                            <div *ngIf="ViolationInfo.evidences" class="col-12">
                                <label>{{ "Evidences" | translate }}</label>
                                <textarea class="form-control" style="height:200px" [(ngModel)]="ViolationInfo.evidences"
                                          readonly></textarea>

                            </div>

                        </div>
                        <div class="form-group row mt-3">
                            <div *ngIf="ViolationInfo.actionTaken" class="col-12">
                                <label>{{ "ActionTaken" | translate }}</label>
                                <textarea class="form-control" style="height:200px" [(ngModel)]="ViolationInfo.actionTaken"
                                          readonly></textarea>

                            </div>

                        </div>

                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="pb-2 pl-3 pr-3  card">
                        <h5 class="mb-0 mt-3 text-secondary">
                            {{ "Decision" | translate }}
                        </h5>
                        <hr class="mb-3" />
                        <div class="form-group mt-3 row">
                            <div *ngIf="ViolationInfo.decisionNo" class="col-6">
                                <label>{{ "decisionNumber" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.decisionNo}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.decisionDate" class="col-6">
                                <label>{{ "decisionDate" | translate }}</label>
                                <span class="form-control" readonly>
                                    {{
ViolationInfo.decisionDate |
                                            toDateTime
                                    }}&nbsp;
                                </span>
                            </div>
                        </div>
                        <div *ngIf="ViolationInfo.decision" class="form-group">
                            <label>{{ "Decision" | translate }}</label>
                            <span class="form-control" readonly>{{ViolationInfo.decision}}&nbsp;</span>
                        </div>
                        <div class="form-group row">
                            <div class="col-lg-6 mt-3">
                                <span class="text-dark">{{ "allowObjection" | translate }} : </span>
                                <span class="text-secondary"
                                      *ngIf="ViolationInfo.allowObjection==true">نعم</span>
                                <span class="text-secondary"
                                      *ngIf="ViolationInfo.allowObjection==false">لا</span>

                            </div>
                            <div class="col-lg-6 row mt-3" *ngIf="ViolationInfo.allowObjection==false">
                                <span class="text-dark">{{ "noteObjection" | translate }} : </span>
                                <span class="text-secondary">{{ ViolationInfo.objectionNotes }}</span>

                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-lg-12" *ngIf="ViolationInfo.companyName !=''">
                    <div class="pb-2 pl-3 pr-3  card">
                        <h5 class="mb-0 mt-3 text-secondary">
                            {{ "dateCompany" | translate }}
                        </h5>
                        <hr class="mb-3" />
                        <div class="form-group mt-3 row">
                            <div *ngIf="ViolationInfo.companyName" class="col-6">
                                <label>{{ "CompanyName" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.companyName}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.crNumber" class="col-6">
                                <label>{{ "CRNo" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.crNumber}}&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12" *ngIf="ViolationInfo.memberName !=''">
                    <div class="pb-2 pl-3 pr-3  card">
                        <h5 class="mb-0 mt-3 text-secondary">
                            {{ "PersonInfo" | translate }}
                        </h5>
                        <hr class="mb-3" />
                        <div class="form-group mt-3 row">
                            <div *ngIf="ViolationInfo.memberName" class="col-6">
                                <label>{{ "personName" | translate }}</label>
                                <span class="form-control" readonly>{{ViolationInfo.memberName}}&nbsp;</span>
                            </div>
                            <div *ngIf="ViolationInfo.memberIdentityNumber" class="col-6">
                                <label>{{ "IdentityNumber" | translate }}</label>
                                <span class="form-control"
                                      readonly>{{ViolationInfo.memberIdentityNumber}}&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="mb-2" />
        <!-- Penalties -->
        <div class="card">
            <h4 style="text-align: center;">
                {{ "Penalties" | translate }}
            </h4>
            <div class="card-body">
                <table class="table table-striped">
                    <thead class="bg-primary">
                        <tr>
                            <th style="width: 10%;">{{'referenceNumber' | translate }}</th>
                            <th style="width: 15%;">{{'PenaltyDescription' | translate }}</th>
                            <th style="width: 10%;">{{ "typePenalty" | translate }}</th>
                            <th style="width: 10%;">{{ "SadadNumber" | translate }}</th>
                            <th style="width: 15%;">{{ "PenaltyAmount" | translate }}</th>
                            <th style="width: 15%;">{{ "penaltyOn" | translate }}</th>
                            <th style="width: 10%;">{{ "penaltyInvoiceStatus" | translate }}</th>

                            <th style="width: 15%;">{{'More' | translate }}</th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ViolationPenalties">

                            <td>
                                {{ item.referenceNo }}
                            </td>


                            <td>
                                {{ item.description }}
                            </td>
                            <td> {{item.isFinancial?"مالية":"ادارية"}}</td>
                            <td>{{ item.sadadNumber }}</td>
                            <td *ngIf="item.amount==0"> __ </td>
                            <td *ngIf="item.amount!=0">{{ item.amount }} ريال</td>
                            <td *ngIf="item.companyName!=''">{{item.companyName}}</td>
                            <td *ngIf="item.memberName!='' ">{{item.memberName}}</td>
                            <td>{{item.penaltyInvoiceStatus ? item.penaltyInvoiceStatus :'-'}}</td>

                            <td>{{item.moreInfo}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <hr class="mb-2" />
        <!-- Attachments -->
        <div class="card">
            <h4 style="text-align: center; padding-top: 5px;">
                {{ "Attachments" | translate }}
            </h4>
            <div class="card-body">
                <table class="table table-striped">
                    <thead class="bg-primary">
                        <tr>
                            <th>{{'fileName'|translate}}</th>
                            <!-- <th>{{'AttachmentType'|translate}}</th> -->
                            <th>{{'descriptionAtt'|translate}}</th>
                            <th>{{'Actions' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let att of ViolationAttachments">
                            <td class="p-3">{{ att.fileName}}</td>
                            <!-- <td class="p-3">{{ att.fileType}}</td> -->
                            <td class="p-3" *ngIf="att.description=='undefined'"> - </td>
                            <td class="p-3" *ngIf="att.description!='undefined'">
                                {{att.description}}
                                <br />

                                <span *ngIf="att.createdOn!=null"
                                      style="font-size: 10px;">
                                    {{'createDate'|translate}}:{{
                                            att.createdOn
                                            | toDateTime
                                    }}
                                </span>

                            </td>

                            <td class="p-3">
                                <a (click)="download(att);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                                    <app-feather-icons [icon]="'download'"></app-feather-icons>
                                </a>
                                <a *ngIf="att.fileType=='image/jpeg' || att.fileType=='image/jpg' || att.fileType=='image/png' || att.fileType=='application/pdf'"
                                   (click)="previewPDF(att,pdfViewer)"
                                   class="btn btn-sm btn-outline-dark ms-1 pb-0">
                                    <app-feather-icons [icon]="'eye'"></app-feather-icons>
                                </a>

                            </td>

                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>






<ng-template #pdfViewer let-modal>

    <div class="modal-body text-center">


        <div style="position:absolute; top:40%; left:45%;  z-index:-1;">
            <div class="spinner-border text-success" role="status">
            </div>
            <br />
            <br />
            <span> {{'uploadFile'|translate}} ...</span>
        </div>
        <i (click)="modal.dismiss('Cross click')" style="position: absolute;z-index: 1;left: 45px;font-size: 25px;"
           class="fa fa-close"></i>

        <!-- -->
        <pdf-viewer *ngIf="pdfFile" [src]="doc" [render-text]="true" [original-size]="false" [show-all]="true"
                    [show-borders]="true">


        </pdf-viewer>

        <img style="width:100%;" *ngIf="!pdfFile" [src]="image" alt="">
    </div>
</ng-template>







